import { Button, Icon, useTheme } from "@merit/frontend-components";
import { Header } from "@src/components";
import { StyleSheet, View } from "react-native";
import { useNavigation } from "@src/hooks";
import type { ViewStyle } from "react-native";

export const AppInfo = () => {
  const { theme } = useTheme();
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
    readonly content: ViewStyle;
  }>({
    container: {
      backgroundColor: theme.colors.background.white,
      flex: 1,
    },
    content: {
      alignItems: "center",
      gap: theme.spacing.l,
    },
  });

  const nav = useNavigation();

  return (
    <View style={styles.container}>
      <Header
        leftElement={<Icon name="closeLargeAction" />}
        leftOnPress={() => {
          nav.goBack();
        }}
        title="About Merit"
        titleBold
        titleLevel="3"
      />
      <View style={styles.content}>
        <Button
          onPress={() => {
            nav.push("ConfigInfo");
          }}
          text="Config Info"
        />
        <Button
          onPress={() => {
            nav.push("DeviceInfo");
          }}
          text="Device Info"
        />
        <Button
          onPress={() => {
            nav.push("OTAInfo");
          }}
          text="OTA Updates"
        />
        <Button
          onPress={() => {
            nav.push("FeatureFlagsInfo");
          }}
          text="Feature Flags"
        />
        <Button
          onPress={() => {
            nav.push("PushNotificationsInfo");
          }}
          text="Push Notifications"
        />
      </View>
    </View>
  );
};
